import iqw from '../assets/images/iqw.png'
import jpw from '../assets/images/jpw.png'
import jdw from '../assets/images/jdw.png'
import fpg from '../assets/images/fpg.png'
import rr from '../assets/images/rr.png'
export const writers = [
    {
        appName: 'Interview Question Writer',
        category:['Utilities'],
        description: 'Create and save Job Interview Questions.',
        avatar: iqw,
        initialPrompt: {
            role: "system",
            content: "place**All your responses should be in HTML format.**"
        },
        route:'iq-writer',
        short:'IQ'
      },
      {
        appName: 'Job Description Writer',
        category:['Utilities'],
        description: 'Create and save Job Descriptions for any job.',
        avatar: jdw,
        initialPrompt: {
            role: "system",
            content: "place**All your responses should be in HTML format.**"
        },
        route:'jd-writer',
        short:'JD'
      },
      {
        appName: 'Job Post Writer',
        category:['Utilities'],
        description: 'Create and save Job Post for any job.',
        avatar: jpw,
        initialPrompt: {
            role: "system",
            content: "place**All your responses should be in HTML format.**"
        },
        route:'jp-writer',
        short:'JP'
      },
      {
        appName: 'Forms and Policies Genie',
        category:['Utilities'],
        description: 'Create and save Forms and Policies.',
        avatar: fpg,
        initialPrompt: {
            role: "system",
            content: "place**All your responses should be in HTML format.**"
        },
        route:'fp-genie',
        short:'FP'
      },
      {
        appName: 'Resume Reviewer *NEW*',
        category:['Utilities'],
        avatar: rr,
        description: 'Review Resumes for potential applicants.',
        initialPrompt: {
            role: "system",
            content: "place**All your responses should be in HTML format.**"
        },
        route:'resume-reviewer',
        short:'RR'
      },
]